/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteDetailScreenQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteDetailScreenQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly adobeAnalyticsIntegration: { readonly __typename?: 'WebsiteAdobeAnalyticsIntegration', readonly adobeAnalyticsAccount: { readonly __typename?: 'AdobeAnalyticsAccount', readonly id: number, readonly status: GraphQL.AdobeAnalyticsAccountStatus } } | null } | null };


export const WebsiteDetailScreenDocument = gql`
    query WebsiteDetailScreen($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    adobeAnalyticsIntegration {
      adobeAnalyticsAccount {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useWebsiteDetailScreenQuery__
 *
 * To run a query within a React component, call `useWebsiteDetailScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteDetailScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteDetailScreenQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteDetailScreenQuery(baseOptions: Apollo.QueryHookOptions<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables> & ({ variables: WebsiteDetailScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>(WebsiteDetailScreenDocument, options);
      }
export function useWebsiteDetailScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>(WebsiteDetailScreenDocument, options);
        }
export function useWebsiteDetailScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>(WebsiteDetailScreenDocument, options);
        }
export type WebsiteDetailScreenQueryHookResult = ReturnType<typeof useWebsiteDetailScreenQuery>;
export type WebsiteDetailScreenLazyQueryHookResult = ReturnType<typeof useWebsiteDetailScreenLazyQuery>;
export type WebsiteDetailScreenSuspenseQueryHookResult = ReturnType<typeof useWebsiteDetailScreenSuspenseQuery>;
export type WebsiteDetailScreenQueryResult = Apollo.QueryResult<WebsiteDetailScreenQuery, WebsiteDetailScreenQueryVariables>;